/**
 * 日历
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';
import DatePicker from 'react-datepicker-okjp';
import Cookies from 'js-cookie';
import Moment from 'moment';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemDate extends ItemContext {
  constructor(props) {
    super(props);

    let notGuardian;
    if (this.props.notGuardian == null) {
      notGuardian = true;
    } else {
      notGuardian = this.props.notGuardian;
    }

    this.state = {
      errorMsg: '',
      dataError: false,
      value: undefined,
      notGuardian,
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
    this.cleanValue(nextProps.dataSource);
  }

  setValue = (dataSource) => {
    const { value, key, formType, extend, onValSetFinished } = dataSource;
    // 值相同的情况下 不触发逻辑
    if (this.state.value === new Moment(value)) {
      return;
    }
    if (value && value !== null && value !== undefined) {
      this.setState({
        value: new Moment(value),
      });
      onValSetFinished && onValSetFinished(key, formType, extend);
    }
  };

  /**
   * 日期变化监听
   * @param val
   */
  onDateChange = (val) => {
    const { key, onChange, errorData, formType, extend } =
      this.props.dataSource;
    const date = new Date(val).getTime();
    const errorMsg = this.getErrorMsg(val, errorData);
    const allow = errorMsg.length === 0;
    this.setState({
      value: val,
      errorMsg,
      dataError: errorMsg && errorMsg.length !== 0,
    });
    onChange && onChange(key, formType, date, allow, extend);
  };

  /**
   * 渲染日历类型
   * @returns {*}
   */
  renderFormLineDataPicker() {
    const lang = Cookies.get('locale') || 'en_US';
    const { errorMsg, value } = this.state;
    const { inputAttr, bottomArea } = this.props.dataSource;
    const { placeholder } = inputAttr || {};
    const { maxDate, minDate, defaultDate } = inputAttr || {}; // 取一下maxDate

    // 单独处理一下minDate maxDate
    const dataAttr = {};
    if (maxDate) {
      dataAttr.maxDate = Moment(maxDate);
    }
    if (minDate) {
      dataAttr.minDate = Moment(minDate);
    }
    if (defaultDate && !value) {
      // change: 如果有既存值就不需要强制指定了
      dataAttr.openToDate = Moment(defaultDate);
    }
    if (value) {
      dataAttr.selected = value;
    }

    return (
      <div className="form-input-box">
        <div className="form-date">
          <DatePicker
            fixedHeight
            dateFormat="YYYY/MM/DD"
            dateFormatCalendar="YYYY MMMM"
            className="datapicker-container input"
            autocomplete="off"
            readOnly
            placeholderText={placeholder}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            {...inputAttr}
            onChange={this.onDateChange}
            locale={lang}
            {...dataAttr}
          />
        </div>
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  // 渲染下部提示
  renderTips(tips, isSpecial) {
    if (!tips || tips.length === 0) {
      return null;
    }
    return (
      <div className="tips-box">
        {tips.map((item, index) => {
          return (
            <div
              key={`tips${isSpecial ? 'Special' : ''}${index}`}
              className={`tips-item ${isSpecial ? 'especial' : ''}`}
            >
              {item}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { dataError, errorMsg, notGuardian } = this.state;
    const { dataSource } = this.props;
    const { bottomTips } = dataSource;

    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineDataPicker()}
        {notGuardian && this.renderTips(bottomTips)}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemDate.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.DATE,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
